import axios from 'axios';
import header from "./header";

const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;

class BikeService {

  addBike(data) {
    return axios.post(`${baseUrl + apiV1}/bike/new`, {data}, header)
  }

  getUserBikes (){
    return axios.get(`${baseUrl + apiV1}/bike/bikes`, header)
  }

  getBikeById (id){
    const res = axios.get(`${baseUrl + apiV1}/bike/id/${id}`, header)
     return res
  }

  updateBike (id, data){
    return axios.put(`${baseUrl + apiV1}/bike/${id}`, {data}, header)
  }

  statusBike(data) {
    return axios.put(`${baseUrl + apiV1}/bike/change/status/`, {data}, header)
  }

   updateAvailableDates (id, data, options){
      return axios.put(`${baseUrl + apiV1}/bike/${id}/available-dates`, {data, options}, header)
   }

   deleteBike (id){
    return axios.delete(`${baseUrl + apiV1}/bike/${id}`, header)
  }

  sendPhotos (bikeId, formData){
    return axios.post(`${baseUrl + apiV1}/bike/${bikeId}/photos`, formData, header)
  }

}

export default new BikeService();
